"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = exports.ModalClose = exports.ModalContent = exports.ModalBackdrop = exports.ModalContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: #6E59F0;\n  font-size: 10px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  background: #F4F4F4;\n  padding: 16px 26px;\n  margin-bottom: 16px;\n  text-align: left;\n  border-radius: 4px 4px 0 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 12px;\n  bottom: auto;\n  left: auto;\n  height: 44px;\n  line-height: 42px;\n  color: black;\n  font-size: 23px;\n  vertical-align: top;\n  text-decoration: none;\n  cursor: pointer;\n  font-weight: 100;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: white;\n  color: #585858;\n  z-index: 21;\n  position: relative;\n  border-radius: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.8);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  text-align: center;\n  z-index: 20;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ModalContainer = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.isOpen ? 'block' : 'none';
}, _knotchWebReactComponents.contentCentered);

exports.ModalContainer = ModalContainer;

var ModalBackdrop = _styledComponents["default"].div(_templateObject2());

exports.ModalBackdrop = ModalBackdrop;

var ModalContent = _styledComponents["default"].div(_templateObject3());

exports.ModalContent = ModalContent;

var ModalClose = _styledComponents["default"].a(_templateObject4());

exports.ModalClose = ModalClose;

var ModalHeader = _styledComponents["default"].div(_templateObject5());

exports.ModalHeader = ModalHeader;

//# sourceMappingURL=styled.js.map